module.exports = __webpack_public_path__ + "static/giraffeanimal5-f5b39fb2ac99d94e74f6dc8ac6298120.png";